// extracted by mini-css-extract-plugin
module.exports = {"root":"Intro-module__root___3tZb3","text":"Intro-module__text___3ik07 Fonts-module__bt___102gf"};